import { get, post } from '../../../../services/request';

export const getExamDataMatrixPagination = (payload) => {
	return post('Examdata/GetExamDataMatrixPagination', payload);
};

export const getAllExamDataMatrixDropDown = () => {
	return get('Examdata/GetallExamDataMatrixDropDown');
};

export const getLatestExamDateRange = () => {
	return get('ExamData/GetLatestExamDateRange');
};
